import { authUser, clientAdmin, clientSetting } from '@/utils/auth';

export default {
 computed: {
  auth() {
   return authUser();
  },

  clientAdmin(){
   return clientAdmin(); 
  },

  clientSetting(){
   return clientSetting(); 
  }

 }
};
